import { isNil } from './utils';
export const getActiveElement = (doc) => {
    var _a;
    const _doc = isNil(doc) ? document : doc;
    let activeElement = _doc.activeElement;
    if (!isNil((_a = activeElement === null || activeElement === void 0 ? void 0 : activeElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.activeElement)) {
        activeElement = getActiveElement(activeElement.shadowRoot);
    }
    return activeElement;
};
